/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `AdminPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  PageHeading: `لوحة القيادة`,
  PageTitle: `لوحة القيادة`,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  PageHeading: `Admin`,
  PageTitle: `Admin`,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  PageHeading: `仪表板`,
  PageTitle: `仪表板`,
});
